import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'

import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import Disclosure from 'modules/payroll_bundle/components/Disclosure'

import * as styles from './index.vanilla.css'

const SkeletonLoader = () => {
  const hasProfessionals = hasFeature('factorial_professionals')

  return (
    <Box gap="s8" style={{ flex: '1' }}>
      <Box flexDirection="row" height="s32" alignItems="center" paddingX="s8">
        <Text.Normal weight="medium" size="300">
          {i18n.t('payroll_bundle.payroll_dashboard.incidences_summary.widget_title')}
        </Text.Normal>
        <Disclosure
          tooltipText={i18n.t(
            'payroll_bundle.payroll_dashboard.incidences_summary.heading_tooltip.tooltip'
          )}
        />
      </Box>
      <Box
        width="full"
        flexDirection="row"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs008' }}
        minHeight="s200"
        style={{ flex: '1' }}
      >
        <Box
          style={{ flex: '1' }}
          padding={'s24'}
          gap={'s16'}
          minWidth="s200"
          justifyContent="spaceBetween"
        >
          <Box gap="s16">
            <Box>
              <Text size="300" weight="medium" color="grey1000">
                <Skeleton height="s24" width="s40" />
              </Text>
              <Text size="200">
                {i18n
                  .t('payroll_bundle.payroll_dashboard.incidences_summary.total_pending')
                  .toLowerCase()}
              </Text>
            </Box>
            {hasProfessionals && (
              <Box>
                <Text size="300" weight="medium" color="grey1000">
                  <Skeleton height="s24" width="s24" />
                </Text>
                <Text size="200">
                  {i18n
                    .t('payroll_bundle.payroll_dashboard.incidences_summary.unread_messages')
                    .toLowerCase()}
                </Text>
              </Box>
            )}
          </Box>
          <Skeleton height="s24" width="s120" />
        </Box>
        <Box minWidth="s1" width="s1" className={styles.lineBackground} />
        <Box padding={'s32'} style={{ flex: '2' }} justifyContent="spaceBetween">
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Skeleton height="s16" width="s80" />
            <Skeleton height="s16" width="s32" />
          </Box>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Skeleton height="s16" width="s64" />
            <Skeleton height="s16" width="s32" />
          </Box>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Skeleton height="s16" width="s48" />
            <Skeleton height="s16" width="s32" />
          </Box>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Skeleton height="s16" width="s80" />
            <Skeleton height="s16" width="s32" />
          </Box>
          <Box width="full" flexDirection="row" justifyContent="spaceBetween">
            <Skeleton height="s16" width="s64" />
            <Skeleton height="s16" width="s32" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SkeletonLoader
